<template lang="pug">
.text-start
  .text.mt-4 Comando para gerar a chave e a requisição:
  .d-flex.flex-row.mt-3
    .code-box.code-box--with-border
      .text.color--info(ref='generateKeyAndRequest')
        | $ openssl req -new -newkey rsa:2048 -keyout
        = ' '
        span.red-background.color--grayscale-dark cert1.key -out
        = ' '
        span.red-background.color--grayscale-dark cert1.csr
    Icon#copy-generate-key-and-request-icon.ms-3.m-auto(
      name='copy',
      @click='doCopy(this.$refs.generateKeyAndRequest, 1)',
      @mouseleave='resetContent(1)',
      style='cursor: pointer'
    )
  .text.mt-3 É necessário preencher apenas o #[strong Common Name]:
  .code-box.mt-3
    p Generating a 2048 bit RSA private key#[br]
      | ...................+++#[br]
      | .......................................................+++#[br]
      | writing new private key to 'cert1.key'#[br]
      | Enter PEM pass phrase:
      span.red-background #{ '<informe a senha de proteção da chave privada>' }#[br]
      | Verifying - Enter PEM pass phrase:
      span.red-background #{ '<confirme a senha>' }#[br]
      | -----#[br]
      | You are about to be asked to enter information that will be incorporated#[br]
      | into your certificate request.#[br]
      | What you are about to enter is what is called a Distinguished Name or a DN.#[br]
      | There are quite a few fields but you can leave some blank#[br]
      | For some fields there will be a default value,#[br]
      | If you enter '.', the field will be left blank.#[br]
      | -----#[br]
      | Country Name (2 letter code) []:
      span.red-background
        = ' '
        | .&nbsp;
      br
      | State or Province Name (full name) []:
      span.red-background
        = ' '
        | .&nbsp;
      br
      | Locality Name (eg, city) []:
      span.red-background
        = ' '
        | .&nbsp;
      br
      | Organization Name (eg, company) []:
      span.red-background
        = ' '
        | .&nbsp;
      br
      | Organizational Unit Name (eg, section) []:
      span.red-background
        = ' '
        | .&nbsp;
      br
      | Common Name (eg, fully qualified host name) []:
      span.red-background cert1&nbsp;#[br]
      | Email Address []:
      span.red-background
        = ' '
        | .&nbsp;
      br

    p Please enter the following 'extra' attributes#[br]
      | to be sent with your certificate request#[br]
      | A challenge password []:
      span.red-background
        = ' '
        | .&nbsp;
      br
  .alert.alert-dismissible.alert-warning.mt-3(role='alert')
    .alert__icon
      Icon(name='circle-info')
    .alert__content
      .text #[strong Importante]: Anote a senha de proteção da chave privada em
        | um local seguro. Não é possível recuperar essa senha posteriormente,
        | e sem ela não será possível utilizar o certificado digital após a emissão.
  .h6.mt-3 #[strong Se quiser verificar os dados presentens na requisição, execute o comando]:
  .d-flex.flex-row.mt-3
    .code-box.code-box--with-border
      .text.color--info(ref='checkData') $ openssl req -noout -text -in
        = ' '
        span.red-background.color--grayscale-dark cert1.csr
    Icon#copy-check-data-icon.ms-3.m-auto(
      name='copy',
      @click='doCopy(this.$refs.checkData, 2)',
      @mouseleave='resetContent(2)',
      style='cursor: pointer'
    )
  .alert.alert-dismissible.alert-success.mt-3(role='alert')
    .alert__icon
      Icon(name='circle-check')
    .alert__content
      .text O conteúdo do arquivo #[strong cert1.csr] deve ser informado no campo #[strong CSR] .
</template>

<script lang="ts">
  import { Tooltip } from 'bootstrap'
  import { defineComponent } from 'vue'
  import Icon from '@/components/Atoms/Icon.vue'

  type TooltipType = {
    id: number
    tooltip: Tooltip
  }

  export default defineComponent({
    name: 'GenerateCSRRequestView',
    components: {
      Icon,
    },
    data() {
      return {
        tooltips: [] as TooltipType[],
      }
    },
    mounted() {
      this.tooltips.push({
        id: 1,
        tooltip: new Tooltip('#copy-generate-key-and-request-icon', {
          title: 'Clique para copiar',
          placement: 'right',
        }),
      })

      this.tooltips.push({
        id: 2,
        tooltip: new Tooltip('#copy-check-data-icon', {
          title: 'Clique para copiar',
          placement: 'right',
        }),
      })
    },
    methods: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      async doCopy(ref: any, id: number) {
        await navigator.clipboard.writeText(ref.textContent.replace('$ ', ''))
        this.tooltips
          .find((tooltip) => tooltip.id === id)
          ?.tooltip.setContent({ '.tooltip-inner': 'Código copiado!' })
      },
      resetContent(id: number) {
        this.tooltips
          .find((tooltip) => tooltip.id === id)
          ?.tooltip.setContent({ '.tooltip-inner': 'Clique para copiar' })
      },
    },
  })
</script>
